import { getBuildVersion } from './src/utils';

export const registerServiceWorker = () => {
  if (
    'serviceWorker' in navigator &&
    'PushManager' in window &&
    'Notification' in window
  ) {
    let buildVersion = getBuildVersion();

    navigator.serviceWorker
      .register(`/firebase-messaging-sw.js?version=${buildVersion}`)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          installingWorker.onstatechange = () => {
            if (
              installingWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              window.location.reload();
            }
          };
        };
      })
      .catch((err) => {
        console.error('[SW]: Registration failed:', err);
      });
  }
};
